import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { uiConfigOptionsAttributes } from '../../types';
import { useUiConfigOption } from '../../providers/UiConfigOptionProvider';
import OrderConfiguration from '../../features/orderConfiguration/OrderConfiguration';
import RenderSvg from '../renderSvg/RenderSvg';
import CatalogueConfiguration from '../../features/catalogueConfiguration/CatalogueConfiguration';
import ThemeConfiguration from '../../features/themeConfiguration/ThemeConfiguration';
import CustomerConfiguration from '../../features/customerConfiguration/CustomerConfiguration';
import AppConfiguration from '../../features/appConfiguration/AppConfiguration';
import HomepageConfiguration from '../../features/homepageConfiguration/HomepageConfiguration';
import AuthConfiguration from '../../features/authConfiguration/AuthConfiguration';
import LanguageConfiguration from '../../features/LanguageConfiguration/LanguageConfiguration';
import FooterConfiguration from '../../features/footerConfiguration/FooterConfiguration';
import MoreOptionsConfiguration from '../../features/moreOptionsConfiguration/MoreOptionsConfiguration';
import SlackAlerts from '../../features/slackAlerts/SlackAlerts';
import OrderTrackingStages from '../../features/orderConfiguration/OrderTrackingStages';
import CartConfiguration from '../../features/orderConfiguration/CartConfiguraton';
import FilterLabel from '../../features/filterLabel/FilterLabel';
import CheckoutConfiguration from '../../features/orderConfiguration/CheckoutConfigurations';
import SchemesConfiguration from '../../features/schemesConfiguration/SchemesConfiguration';
import HelpdeskConfiguration from '../../features/helpdeskOption/HelpdeskOption';
import PasswordConfiguration from '../../features/passwordConfiguration/PasswordConfiugration';
import PasswordValidation from '../../features/passwordValidations/PasswordValidations';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import store from '../../stateManagement/store';
import OutletActivityTabsConfiguration from '../../features/outletActivityTabsConfiguration/OutletActivityTabsConfiguration';
import ConfigComponents from '../uiConfig/ConfigComponents';
import SFAConfigurations from '../../features/sfaConfigurations/SFAConfigurations';
export const uiConfigOptions: uiConfigOptionsAttributes[] = [
    {
        id: "App",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="AppConfigurationIcon" width="25%"/>,
        targetComponent: <AppConfiguration />
        // targetComponent: <ConfigComponents configName="app_configuration" key="app_configuration"/>
    },
    {
        id: "Order",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="OrderConfigurationIcon" width="20%"/>,
        targetComponent: <OrderConfiguration />,
        // targetComponent: <ConfigComponents configName="order_configuration" key="order_configuration"/>
    },
    {
        id: "Order Tracking",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="OrderConfigurationIcon" width="20%"/>,
        targetComponent: <OrderTrackingStages />,
        // targetComponent: <ConfigComponents configName="order_tracking_configuration" key="order_tracking_configuration"/>
    },
    {
        id: "Cart",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="OrderConfigurationIcon" width="20%"/>,
        targetComponent: <CartConfiguration />,
        // targetComponent: <ConfigComponents configName="cart_configuration" key="cart_configuration"/>
    },
    {
        id: "Checkout",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="OrderConfigurationIcon" width="20%"/>,
        targetComponent: <CheckoutConfiguration />,
        // targetComponent: <ConfigComponents configName="checkout_configuration" key="checkout_configuration"/>
    },
    // {
    //     id: "Feature",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    {
        id: "Catalogue",
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        sfg: faMagnifyingGlass,
        targetComponent: <CatalogueConfiguration />,
        // targetComponent: <ConfigComponents 
        // configName="catalogue_configuration" 
        // key="catalogue_configuration"/>
    },
    {
        id: "Schemes",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <SchemesConfiguration />,
    },
    {
        id: "HelpDesk Options",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <HelpdeskConfiguration />,
    },
    // {
    //     id: "Schemes",
    //     sfg: faMagnifyingGlass,
    //     icon:<RenderSvg name="catalogueIcon" width="25%"/>,
    //     targetComponent: <SchemesConfiguration />,
    // },
    // {
    //     id: "HelpDesk Options",
    //     sfg: faMagnifyingGlass,
    //     icon:<RenderSvg name="catalogueIcon" width="25%"/>,
    //     targetComponent: <HelpdeskConfiguration />,
    // },
    // {
    //     id: "Menu",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    // {
    //     id: "Firebase",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    // {
    //     id: "Schemes",
    //     sfg: faMagnifyingGlass,
    //     icon:<RenderSvg name="catalogueIcon" width="25%"/>,
    //     targetComponent: <SchemesConfiguration />,
    // },
    // {
    //     id: "HelpDesk Options",
    //     sfg: faMagnifyingGlass,
    //     icon:<RenderSvg name="catalogueIcon" width="25%"/>,
    //     targetComponent: <HelpdeskConfiguration />,
    // },
    {
        id: "Theme",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="ThemeConfigurationIcon" width="25%"/>,
        targetComponent: <ThemeConfiguration />,
        // targetComponent: <ConfigComponents configName="theme_configuration" key="theme_configuration"/>
    },
    // {
    //     id: "Alerts",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    // {
    //     id: "Intent",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    // {
    //     id: "App Sharing",
    //     sfg: faMagnifyingGlass,
    //     targetComponent: <></>,
    // },
    {
        id: "Customer",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="CustomerConfigurationIcon" width="25%"/>,
        targetComponent: <CustomerConfiguration />,
        // targetComponent: <ConfigComponents configName="customer_configuration" key="customer_configuration"/>
    },
    {
        id: "Homescreen",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="homepageIcon" width="25%"/>,
        targetComponent: <HomepageConfiguration />,
    },
    {
        id: "Login Page",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="AuthConfigurationIcon" width="20%"/>,
        targetComponent: <AuthConfiguration/>,
        // targetComponent: <ConfigComponents configName="authentication_configuration" key="authentication_configuration"/>,
    },
    {
        id: "Language",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <LanguageConfiguration />,
        // targetComponent: <ConfigComponents configName="language_configuration" key="language_configuration"/>,
    },
    {
        id: "Footer",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <FooterConfiguration />,
    },
    // {
    //     id: "App Build",
    //     sfg: faMagnifyingGlass,
    //     icon:<RenderSvg name="catalogueIcon" width="25%"/>,
    //     targetComponent: <AppBuildConfiguration />,
    // },
    {
        id: "More Options",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <MoreOptionsConfiguration />,
    },
    {
        id: "Slack Alerts",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <SlackAlerts />,
    },
    {
        id: "Filter labels",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="catalogueIcon" width="25%"/>,
        targetComponent: <FilterLabel />,
    },
    {
      id: 'Password Config',
      sfg: faMagnifyingGlass,
      icon: <RenderSvg name='catalogueIcon' width='25%' />,
      targetComponent: <PasswordConfiguration />,
    },
    {
        id: "Password Complexity",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="AuthConfigurationIcon" width="20%"/>,
        targetComponent: <PasswordValidation />
    }
];
export const sfaConfigOptions: uiConfigOptionsAttributes[] = [
    {
        id: "outlet ActivityTabs",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="AppConfigurationIcon" width="25%"/>,
        targetComponent: <OutletActivityTabsConfiguration />
    },
    {
        id: "SFA Configuration",
        sfg: faMagnifyingGlass,
        icon:<RenderSvg name="CustomerConfigurationIcon" width="25%"/>,
        targetComponent: <SFAConfigurations />,
        // targetComponent: <ConfigComponents configName="sfa_configurations" key="sfa_configurations"/>,
    }

]
const UiConfigSidebar = () => {
    const [accessibleUiConfigs,setAccessibleUiConfigs] = useState<uiConfigOptionsAttributes[]>([]);
    const [accessibleSfaUiConfigs,setAccessibleSfaUiConfigs] = useState<uiConfigOptionsAttributes[]>([]);
    const layoutConfig = store.getState().portalConfigState?.layoutConfig;
    const { activeOption ,setActiveOption} = useUiConfigOption();
    const handleOptionClick=(option:uiConfigOptionsAttributes)=>{
       setActiveOption(option)
    }
    const { translate } = usePortalTranslation();
    useEffect(() => {
        const uiConfigIds = layoutConfig?.find((configObj) => configObj.name === "uiConfigLayout")?.value ?? ["Theme"]; //default Theme
        const newAccessibleUiConfigs = [];
        const newAccessibleSfaUiConfigs = [];
        for(let configId of uiConfigIds){
            const uiConfigObj = uiConfigOptions.find((configOption) => configOption.id === configId);
            if(uiConfigObj){
                newAccessibleUiConfigs.push(uiConfigObj);
            }else{
                const sfaConfigObj = sfaConfigOptions.find((configOption) => configOption.id === configId);
                if(sfaConfigObj){
                    newAccessibleSfaUiConfigs.push(sfaConfigObj);
                }
            }
        }
        setAccessibleUiConfigs(newAccessibleUiConfigs);
        setAccessibleSfaUiConfigs(newAccessibleSfaUiConfigs);
    },[layoutConfig])
    return (
        <div className="ui_sidebar">
            {accessibleUiConfigs.length>0 && <div className="sidebar_header">
                <h5>{translate(TranslationEnum.ui_config,"CONFIGURATION MENU")}</h5>
            </div>}
            <div className='config_option_container'>
            {accessibleUiConfigs.length>0 && <div className="options_container">
                {accessibleUiConfigs.map((option) => {
                    return (
                        <div key={option.id} onClick={()=>handleOptionClick(option)} className={activeOption?.id === option.id ? "uisidebar_option uiconfig_active_option" : "uisidebar_option"}>
                            {option.icon?option.icon:<FontAwesomeIcon icon={option.sfg} />}
                            <span>{translate(TranslationEnum.ui_config,option.id)}</span>
                        </div>
                    );
                })}
            </div>}

            {/* for SFA options */}
           {accessibleSfaUiConfigs.length>0 && <div className="sidebar_header">
                <h5>SFA OPTIONS</h5>
            </div>}
            <div className="options_container">
                {accessibleSfaUiConfigs.map((option) => {
                    return (
                        <div key={option.id} onClick={()=>handleOptionClick(option)} className={activeOption?.id === option.id ? "uisidebar_option uiconfig_active_option" : "uisidebar_option"}>
                            {option.icon?option.icon:<FontAwesomeIcon icon={option.sfg} />}
                            <span>{option.id}</span>
                        </div>
                    );
                })}
            </div>
            </div>
        </div>
    )
}

export default UiConfigSidebar